import Repository from "../Repository";

export default {
  login: (credentials) => {
    return Repository.post('/auth/login', credentials);
  }
}
